<ion-header>
    <ion-toolbar color="secondary">
        <ion-title>Release of Liability</ion-title>

        <ion-buttons slot="end">
            <ion-button (click)="onClose()">
                <i class="material-symbols-outlined">close</i>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content fullscreen>
    <main>
        <section>
            @if (experience === 'trailer') {
            <h2>Risk Acknowledgment</h2>
            <p>
                By using Drive & Tow to arrange a pickup job, I understand and accept all risks involved, including those related to
                driver conduct, travel conditions, and negligence. I acknowledge that I participate entirely at my own risk.
            </p>

            <h2>Property Insurance</h2>
            <p>
                I understand that neither Drive & Tow nor the driver provides insurance for my cargo or trailer. The value of my
                property is not covered, and any responsibility is limited to the job fee paid through the App.
            </p>

            <h2>Restricted Items</h2>
            <p>
                I agree not to request the transport of passengers, animals, fireworks, drugs, weapons, fine art, hazardous materials, 
                or illegal items through Drive & Tow. I also agree not to request heavy commercial freight, oversized industrial loads, 
                or any cargo that exceeds standard pickup truck safety limits. This ensures safe, legal, and reliable transport for both drivers and cargo owners.
            </p>

            <h2>Cargo Handling & Trailer Hitching</h2>
            <p>
                I understand that drivers are not automatically responsible for loading or unloading cargo into their truck beds. 
                These responsibilities must be agreed upon between me and the driver using the App's chat feature, or confirmed together at the pickup location. 
                For trailers, drivers are responsible for properly hitching and securing the trailer since they operate the vehicle.
            </p>

            <h2>Medical Care</h2>
            <p>
                I understand that I am solely responsible for my own medical expenses in the event of injury. Drive & Tow and its
                affiliates are not liable for such costs.
            </p>

            <h2>Cancellation Policy</h2>
            <p>
                I agree to Drive & Tow's cancellation policy. Jobs canceled less than 2 days after approval are subject to a $10.00
                cancellation fee.
            </p>

            <h2>Duration of Agreement</h2>
            <p>This release applies to all jobs I request or complete through Drive & Tow.</p>

            <h2>Release and Discharge</h2>
            <form [formGroup]="form" (ngSubmit)="onAccept()">
                <mat-checkbox formControlName="accept" color="primary">
                    By accepting, I release and discharge Drive & Tow, its affiliates, and its independent drivers from any legal
                    claims related to property damage, loss, injury, or disputes arising from my use of the App.
                </mat-checkbox>

                <ion-button type="submit" expand="block" [disabled]="form.invalid">Accept</ion-button>
                <div class="link" (click)="onClose()">Decline</div>
            </form>
            } @else {
            <h2>Risk Acknowledgment</h2>
            <p>
                By accepting a job through Drive & Tow, I understand and accept all risks, including those related to travel
                conditions, accidents, or negligence. I acknowledge that I perform these activities entirely at my own risk.
            </p>

            <h2>Insurance Responsibility</h2>
            <p>
                I agree that I must maintain valid auto insurance that includes Liability Coverage and PIP (as required by state
                law). I understand my personal auto insurance does not cover damage to cargo or trailers unless I also carry proper
                commercial or cargo insurance.
            </p>

            <h2>Independent Contractor Status</h2>
            <p>
                I acknowledge that I am an independent contractor, not an employee, partner, or agent of Drive & Tow. I am solely
                responsible for my vehicle, equipment, compliance with laws, and work performed.
            </p>

            <h2>Restricted Items</h2>
            <p>
                I agree not to accept jobs that involve transporting passengers, animals, fireworks, drugs, weapons, fine art, hazardous materials, 
                or illegal items through Drive & Tow. I also agree not to accept jobs involving heavy commercial freight, oversized industrial loads, 
                or any cargo that exceeds standard pickup truck safety limits. This ensures safe, legal, and reliable transport for both drivers and cargo owners.
            </p>

            <h2>Cargo Handling & Trailer Hitching</h2>
            <p>
                I understand that I am not automatically responsible for loading or unloading cargo into my truck bed. These responsibilities must be agreed upon with 
                the requester using the App's chat feature, or confirmed together at the pickup location. For trailers, I am responsible for properly hitching and 
                securing the trailer since I operate the vehicle.
            </p>

            <h2>Medical Responsibility</h2>
            <p>
                I am responsible for my own medical expenses in the event of injury. Drive & Tow and its affiliates are not liable
                for such costs.
            </p>

            <h2>Cancellation Policy</h2>
            <p>
                I accept Drive & Tow's cancellation policy. If I cancel less than 3 days after approval, a $10.00 cancellation fee
                will apply.
            </p>

            <h2>Duration of Agreement</h2>
            <p>This release applies to all jobs I accept or complete through Drive & Tow.</p>

            <h2>Release and Discharge</h2>
            <form [formGroup]="form" (ngSubmit)="onAccept()">
                <mat-checkbox formControlName="accept" color="primary">
                    By accepting, I release and discharge Drive & Tow, its affiliates, and users from any legal claims related to
                    property damage, loss, injury, or disputes arising from my participation.
                </mat-checkbox>

                <ion-button type="submit" expand="block" [disabled]="form.invalid">Accept</ion-button>
                <div class="link" (click)="onClose()">Decline</div>
            </form>
            }
        </section>
    </main>
</ion-content>
